// src/index.jsx 加 AntD 样式导入
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'antd/dist/reset.css'; // 关键：导入 AntD 全局样式

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);